// Shared look + positioning for every popup that hangs off the collapsed left rail
// (profile menu, Onboard progress preview, and any future ones). Centralized here so
// a new rail popup gets the right background/spacing "for free" instead of every
// caller re-tuning its own pixel offsets.

// Visual surface — a proper grey in each mode: dark grey on dark, light grey on light,
// so it stays a distinct "popup" surface without going stark white/black.
export const RAIL_POPUP_BG = (theme) => (theme.palette.mode === "dark" ? "#2A2A2A" : "#F3F3F5");
export const RAIL_POPUP_TEXT = (theme) => (theme.palette.mode === "dark" ? "#F5F5F5" : "#1A1A1A");
export const RAIL_POPUP_SUBTEXT = (theme) => (theme.palette.mode === "dark" ? "#9CA3AF" : "#6B7280");
export const RAIL_POPUP_DIVIDER = (theme) =>
  theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";
export const RAIL_POPUP_HOVER = (theme) =>
  theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)";

export const railPopupItemSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  borderRadius: "8px",
  px: 1.25,
  py: 0.75,
  "&:hover": { backgroundColor: RAIL_POPUP_HOVER },
};

// Base Paper styling every rail popup shares (background/border/shadow/radius).
// Callers spread this then add their own `width` and the computed `ml` below.
export const railPopoverPaperSx = {
  boxShadow: "0 16px 40px rgba(0,0,0,0.22)",
  borderRadius: "14px",
  border: "1px solid",
  borderColor: RAIL_POPUP_DIVIDER,
  overflow: "hidden",
  backgroundColor: RAIL_POPUP_BG,
  color: RAIL_POPUP_TEXT,
};

// How far clear of the rail's own border every popup should sit.
export const RAIL_POPUP_GAP_PX = 6;

// Rail buttons are centered within a rail column wider than themselves (mx:"auto"),
// so a popup anchored to a BUTTON's edge needs a different offset than one anchored
// to the RAIL's edge — and that inset changes whenever the button's own size changes
// (e.g. the compact-height breakpoint shrinks buttons from 46-48px down to 40px).
// This computes the real distance live from the DOM instead of a guessed constant,
// so it stays correct at any breakpoint and for any button width.
export function getRailPopoverOffsetPx(anchorEl, railEl, gap = RAIL_POPUP_GAP_PX) {
  if (!anchorEl || !railEl) return gap;
  const anchorRect = anchorEl.getBoundingClientRect();
  const railRect = railEl.getBoundingClientRect();
  return Math.max(gap, railRect.right - anchorRect.right + gap);
}
